export const PLP_Items_Per_Page = 60
